import { render, staticRenderFns } from "./ResetPasswordBlock.vue?vue&type=template&id=4b11ce5a"
import script from "./ResetPasswordBlock.vue?vue&type=script&lang=ts"
export * from "./ResetPasswordBlock.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports